import TermContainer from "./TermContainer";

export default TermContainer;
